import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom'
import TutorSidebar from '../../TutorSidebar/TutorSidebar'
import { getTutorCompletedAssListData } from '../../../../Redux/action/TutorAction';
import Beatloader from '../../../../Common/BeatLoader';
import ResponsivePagination from '../../../../Common/Pagination';

const TutorCompletedAssessment = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getTutorCompletedAssListData({}))
    }, []);

    const {

        loadingTutorCompletedAssListApi,
        TutorCompletedAssListApiData,
        TutorCompletedAssListApiError

    } = useSelector(state => state?.TutorReducer);

    //pagination

    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1); // ✅ 1-based page index
    const dataPerPage = 10;

    useEffect(() => {
        if (!TutorCompletedAssListApiData) return;

        const start = (currentPage - 1) * dataPerPage;
        const end = start + dataPerPage;

        setCurrentData(TutorCompletedAssListApiData.slice(start, end));
        setPageCount(Math.ceil(TutorCompletedAssListApiData.length / dataPerPage));
    }, [currentPage, dataPerPage, TutorCompletedAssListApiData]);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0);
    };

    return (
        <div className='pagination-component'>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Completed Assessments
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <h4 className="mb-3">Completed Assessments</h4>
                                {loadingTutorCompletedAssListApi ?
                                    <Beatloader />
                                    :
                                    <div className="row">
                                        {TutorCompletedAssListApiData?.length ?
                                            currentData?.map((data) => (
                                                <div className="col-lg-6 mt-3 col-md-6" key={data?.id}>
                                                    <Link to={`/tutor/completed-assessment-student-list/${btoa(data?.id)}`}>
                                                        <div
                                                            className="card input-card-form notescard bg-white "

                                                        >
                                                            <div className="card-body">
                                                                <div className="row">
                                                                    <div className="col-lg-12 d-flex justify-content-end">
                                                                        <p className="mb-0" style={{ fontSize: 16 }}>
                                                                            {data?.assesment_date}
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-lg-4 my-2">
                                                                        <div
                                                                            className="card input-card-form mb-0 h-100"
                                                                            style={{ backgroundColor: "aliceblue" }}
                                                                        >
                                                                            <div className="card-body d-flex justify-content-center align-items-center mb-0">
                                                                                <h3 className="mb-0">{data?.question_type ? 'S' : 'O'}</h3>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-8 d-flex flex-column justify-content-center align-items-start my-2">
                                                                        <h6 className="mb-0 text-primary">Assessment Name : {data?.assesment_name}</h6>
                                                                        <h6 className="mb-0 text-primary">Course Name : {data?.course?.name}</h6>
                                                                        <p className="mb-0">Class/Grade/General : {data?.course?.category?.name}</p>
                                                                        <p className="mb-0">Subject : {data?.course?.subcategory?.name}</p>
                                                                        <p className="mb-0">Module : {data?.course?.childcategory?.name}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            ))
                                            :
                                            <div className='no-data-img'>
                                                <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                            </div>}

                                        {pageCount > 1 && (
                                            <ResponsivePagination
                                                pageCount={pageCount}
                                                currentPage={currentPage}
                                                handlePageClick={handlePageClick}
                                            />
                                        )}
                                    </div>



                                }
                            </main>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    )
}

export default TutorCompletedAssessment